/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {getFlow} from '../api'

export const useMutationGetFlow = createReactQueryMutationHook('getFlow', getFlow)
